import { CelebrationTable } from "@components/adapters/celebration/Table";
import type {
  TableColumn,
  TableProps,
} from "@components/contracts/Table.types";

export const Table = <DataType extends Record<string, unknown>>(
  props: TableProps<DataType>
) => <CelebrationTable {...props} />;

export type { TableColumn, TableProps };
